import script from "./StandardRigid.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardRigid.vue?vue&type=script&setup=true&lang=js"

import "./StandardRigid.vue?vue&type=style&index=0&id=723feeec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723feeec"]])

export default __exports__